__turbopack_context__.v({
  "logo": "MDy_oq_logo",
});
